export const ticketPriority = [
  { id: "low", name: "Low" },
  { id: "medium", name: "Medium" },
  { id: "high", name: "High" },
  { id: "critical", name: "Critical" },
];

export const ticketStatus = [
  { id: "open", name: "Open" },
  { id: "in_progress", name: "In Progress" },
  { id: "resolved", name: "Resolved" },
  { id: "closed", name: "Closed" },
];

export const getTicketStatusColor = (status) => {
  switch (status) {
    case "new":
      return "info";
    case "open":
      return "warning";
    case "in_progress":
      return "secondary";
    case "resolved":
      return "success";
    case "closed":
      return "default";
    default:
      return "default";
  }
};

export const getTicketPriorityColor = (priority) => {
  switch (priority) {
    case "low":
      return "success.main";
    case "medium":
      return "warning.light";
    case "high":
      return "error.dark";
    case "critical":
      return "error.main";
    default:
      return "default";
  }
};

export const getTicketTimeElapsed = (dateString) => {
  const created = new Date(dateString);
  const now = new Date();
  const diffMs = now - created;

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays > 0) return `${diffDays}d ago`;

  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  if (diffHours > 0) return `${diffHours}h ago`;

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  return `${diffMinutes}m ago`;
};

export const formatTicketDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
